export const forceScrolling = (ref : any) => {
  let container = (ref.current as any) as HTMLElement;
  if (container && (container.scrollHeight - container.clientHeight) > 0) {
    container.scrollTop = container.scrollHeight - container.clientHeight
  }
}